import {
    takeLatest,
    call,
} from 'redux-saga/effects';
import {
    setSessionStorageItemJson,
    getSessionStorageItemJson,
} from '@vfde-sails/storage';
import {
    CREATE_INITIAL_STORAGE,
} from './constant';
import {SAILS_GK_LP_STORAGE} from 'Constant';
import {SailsGkLandingpageStorage} from 'Container/Storage/interface';

/**
 * Create initial storage from NSF storage
 */
export function* createInitialStorageSaga () {
    const sailsStorage = (yield call(getSessionStorageItemJson, SAILS_GK_LP_STORAGE)) as SailsGkLandingpageStorage;

    if (sailsStorage === null || (sailsStorage && Object.keys(sailsStorage).length === 0)) {
        // if storage wasn't set before, initialize
        const newSailsStorage: SailsGkLandingpageStorage = {
            multipickerSelection: '00000000',
        };
        yield call(setSessionStorageItemJson, SAILS_GK_LP_STORAGE, newSailsStorage);
    }
}

/**
 * Update storage
 *
 * @param name
 * @param storage
 * @param syncSailsToNsf
 * @param oldStorage Optional pass the old storage object so we don't need to get it here again
 */
export function* updateStorageSaga (selectedOptions: string) {
    const sailsStorage = yield call(getSessionStorageItemJson, SAILS_GK_LP_STORAGE);
    sailsStorage.multipickerSelection = selectedOptions;
    yield call(setSessionStorageItemJson, SAILS_GK_LP_STORAGE, sailsStorage);
}

/**
 * Storage saga watcher
 */
export default function* storageSaga () {
    yield takeLatest(CREATE_INITIAL_STORAGE, createInitialStorageSaga);
}
